import { render } from "./Students.vue?vue&type=template&id=091b0257&bindings={}"
import script from "./Students.vue?vue&type=script&lang=ts"
export * from "./Students.vue?vue&type=script&lang=ts"
script.render = render

export default script